import '../style/months-select.scss'
import { formatDate } from '../utils'

export default {
  functional: true,
  render (h, context) {
    const { data = [], handleEvent } = context.props
    if (!Array.isArray(data)) {
      return null
    }
    return <div class='kye-date-picker2-month-selected'>
      <div class='title'>已选项</div>
      <div class='wrap'>
        {
          data.reduce((acc, val, index) => {
            // const { label } = item || {}
            if (val) {
              acc.push(<div class='item'>
                <span class='label'>{formatDate(val, 'yyyy-MM')}</span>
                <i class='el-icon-close btn' on-click={() => handleEvent('delete', {data, val, index})}></i>
              </div>)
            }
            return acc
          }, [])
        }
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/basic/months-select.js